import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ITaskComment, ITaskCommentDto, ITaskCommentsFilter } from '../task-comment/task-comment.interface';
import { TaskCommentService } from '../task-comment/task-comment.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { HelpVideoModalComponent } from '../../../../shared/components/help-video-modal/help-video-modal.component';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { WorkersModalComponent } from '../../../workers-page/workers/workers-modal/workers-modal.component';
import { watsappURL } from '../../../../../env-config';
import { ITask } from '../task.interface';
import { TaskModalComponent } from '../task-modal/task-modal.component';
import { IClient } from '../../../clients-page/clients/clients.interface';
import { ClientsModalComponent } from '../../../clients-page/clients/clients-modal/clients-modal.component';
import { IFile } from '../../../../shared/components/files/file.interface';
import { FileViewModalComponent } from '../../../../shared/components/file-view-modal/file-view-modal.component';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-task-comments',
  templateUrl: './task-comments.component.html',
  styleUrls: ['./task-comments.component.css']
})
export class TaskCommentsComponent implements OnInit {
  comments: ITaskCommentDto[] = [];
  loading: boolean = true;
  thereAreMore: boolean = false;
  filter: ITaskCommentsFilter = {
    sort: '-createdAt',
    skip: 0,
    limit: 20,
    filters: {}
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: { [key: string]: string } = {};
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  safeSrc: SafeResourceUrl;
  totalMoreMinTutorial = false;

  constructor(
    public _TaskCommentService: TaskCommentService,
    public _WorkersService: WorkersService,
    public _ClientsService: ClientsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private _AuthService: AuthService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    self = this;
    this.registerStringBroadcast();
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/ibDZbolcrwQ?si=laTuWtfpZW6cdXmJ");
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this._TaskCommentService.getCommentsCount(this.filter).subscribe((count: any) => {
      this.totalMoreMinTutorial = count <= 3;
      this.getTaskComments(true);
    })
    //this.getTaskComments(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTaskComments(true);
      }
    }, 1000);
  }

  getTaskComments(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.comments = [];
      this.clearSelection();
    }
    this._TaskCommentService.getComments(this.filter).subscribe((comments: ITaskCommentDto[]) => {
      this.comments = _.concat(this.comments, comments);
      const filter: any = this.filter;
      this.thereAreMore = comments.length >= filter.limit;
      this.loading = false;
      this.ref.detectChanges();
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getTaskComments();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortTaskComments(sort: Sort | string) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getTaskComments(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = {};
    this.getTaskComments(true);
  }

  openHelpVideoModal() {
    let config = new MatDialogConfig();
    config.width = '1100px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(HelpVideoModalComponent, config);
    self.dialogRef.componentInstance.helpLink = this.safeSrc;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.getTaskComments(true);
    });
  }


  openDeleteTaskCommentConfirm(comment: ITaskComment, hardDelete: boolean = false) {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Comentario",
      message: "Esta seguro que desea eliminar este comentario?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskCommentService.deleteComment(comment, hardDelete).subscribe(result => {
            this.getTaskComments(true);
          })
        }
      });
  }

  clearSelection() {
    this.selection = { all: false }
  }

  toggleSelection(_id?: string) {
    if (_id) {
      this.selection.all = false;
      this.selection[_id] = !this.selection[_id];
    } else {
      this.selection = { all: !this.selection.all }
    }
  }

  openWorkerModal(worker: IWorker) {
    if (!worker._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(WorkersModalComponent, config);
    self.dialogRef.componentInstance.worker = worker;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openWorkerWhatsapp(workerId: any) {
    this._WorkersService.getWorker(workerId).subscribe(worker => {
      const phones = _.get(worker, 'phones', []);
      console.log(phones);
      phones.forEach((phone: any) => {
        window.open(watsappURL({ text: '', phone: phone.number }))
      });
    })
  }

  openTaskModal(task: ITask) {
    if (!task._id) return;
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openClientModal(client: IClient) {
    if (!client._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(ClientsModalComponent, config);
    self.dialogRef.componentInstance.client = client;
    self.dialogRef.componentInstance.readOnly = true;
    self.dialogRef.componentInstance.showEdit = false;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openFile(file: IFile) {
    if (!file._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(FileViewModalComponent, config);
    self.dialogRef.componentInstance.file = file;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }

  openPdf(file: IFile) {
    if (!file._id) return;
    window.open(file.fileUrl, "_blank");
  }

  openTasksList() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks']);
  }

  openTasksByStatus() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'tasks-status']);
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "Ups!",
      message: "El enlace se encuentra en construccion",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  exportTaskComments() {
    this._TaskCommentService.exportTaskComments(_.cloneDeep(this.filter));
  }
}